import Spinner from 'src/javascripts/components/utilities/Spinner';
import * as filestack from 'filestack-js';
import * as fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';

// Pick an image and update an associated attribute in DB
export default function() {

  // Function to sanitize file names
  function sanitizeFileName(fileName) {
    // Get file extension
    const lastDotIndex = fileName.lastIndexOf('.');
    const name = lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
    const extension = lastDotIndex > 0 ? fileName.substring(lastDotIndex) : '';
    
    // Remove or replace non-English characters and special characters
    const sanitizedName = name
      .normalize('NFD') // Decompose accented characters
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
      .replace(/[^a-zA-Z0-9\-_]/g, '_') // Replace non-alphanumeric chars with underscore
      .replace(/_{2,}/g, '_') // Replace multiple underscores with single
      .replace(/^_+|_+$/g, '') // Remove leading/trailing underscores
      .toLowerCase(); // Convert to lowercase
    
    // Ensure name isn't empty
    const finalName = sanitizedName || 'file';
    
    return finalName + extension.toLowerCase();
  }

  // Set environment and account id for AWS path vars
  $('.docs-filepicker').each(function(i, elem) {
    let fileInput    	= $(elem);
	  let env 					= fileInput.data("env");
	  let accountUrl 		= $('body').data("account-url");
    var progressBar  	= $("<div class='bar'></div>");
    var barContainer 	= $("<div class='progress'></div>").append(progressBar);
    $('#fileUploadProgress').append(barContainer);
    fileInput.fileupload({
      fileInput:       	fileInput,
      url:             	fileInput.data('url'),
      type:            	'POST',
      autoUpload:       true,
      formData:         fileInput.data('form-data'),
      paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
      dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
      replaceFileInput: false,
      add: function (e, data) {
        // Sanitize file name before upload
        if (data.files && data.files[0]) {
          const originalName = data.files[0].name;
          const sanitizedName = sanitizeFileName(originalName);
          
          // Create a new File object with sanitized name
          const sanitizedFile = new File([data.files[0]], sanitizedName, {
            type: data.files[0].type,
            lastModified: data.files[0].lastModified
          });
          
          data.files[0] = sanitizedFile;
        }
        
        // Proceed with upload
        data.submit();
      },
      progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        progressBar.css('width', progress + '%')
      },
      start: function (e) {
        progressBar.
          css('background', '#8c81d1').
          css('display', 'block').
          css('width', '0%').
          text("Loading...");
      },
      done: function(e, data) {
        progressBar.text("Uploading done");

        // extract key from response
        let key = $(data.jqXHR.responseXML).find("Key").text();
        let accountUrl = $('body').attr('data-account-url');
        let params = {};

        // Set spinner so user knows in progress
        $('.filepicker-container .filepicker-label').addClass('opaque');
        Spinner($('.filepicker-container'));

        // Add key to hidden field
        let cloudfrontSrc = fileInput.data('cloudfront-src');
        $('#file_url').val(cloudfrontSrc + '/' + key);

      },
      fail: function(e, data) {
        progressBar.
          css("background", "red").
          text("Failed");
      }
    });
  });

}
